// Recursive check for text content in Lexical JSON rich text nodes.
// Handles nested structures like links (paragraph > link > text),
// lists (list > listItem > text), and other deeply nested formatting.

function hasTextContent(node: unknown): boolean {
  if (!node || typeof node !== 'object') return false
  const n = node as Record<string, unknown>
  if (typeof n.text === 'string' && n.text.trim()) return true
  if (Array.isArray(n.children)) {
    return n.children.some(hasTextContent)
  }
  return false
}

export function hasRichTextContent(field: unknown): boolean {
  if (!field || typeof field !== 'object') return false
  const root = (field as { root?: { children?: unknown[] } }).root
  if (!root?.children?.length) return false
  return root.children.some(hasTextContent)
}
